import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faMapMarkerAlt, faPlane } from '@fortawesome/free-solid-svg-icons';
import {
  isAirport,
  locationCountLabel,
  locationPrimaryLabel,
  locationSecondaryLabel,
  PickupCatalogLocation,
} from '../../utils/pickupLocationGroups';
import { Chevron, Row, RowCount, RowIcon, RowName, RowText } from './styles';

/** Bolds the first match of `query` in `text` (FR-022). */
export function Highlight({ text, query }: { text: string; query?: string }) {
  const q = (query ?? '').trim().toLowerCase();
  const at = q ? text.toLowerCase().indexOf(q) : -1;
  if (at < 0) return <>{text}</>;
  return (
    <>
      {text.slice(0, at)}
      <mark>{text.slice(at, at + q.length)}</mark>
      {text.slice(at + q.length)}
    </>
  );
}

export function GroupRow({
  name,
  count,
  selected,
  tall,
  onChoose,
  testId,
}: {
  name: string;
  count: number;
  selected: boolean;
  tall?: boolean;
  onChoose: () => void;
  testId?: string;
}) {
  return (
    <Row
      type="button"
      role="option"
      aria-selected={selected}
      $tall={tall}
      onClick={onChoose}
      data-testid={testId}
    >
      <RowName>{name}</RowName>
      <RowCount className="muted">{locationCountLabel(count)}</RowCount>
      <Chevron className="muted" aria-hidden>
        <FontAwesomeIcon icon={faChevronRight} />
      </Chevron>
    </Row>
  );
}

export function LocationRow<T extends PickupCatalogLocation>({
  location,
  selected,
  query,
  tall,
  onChoose,
}: {
  location: T;
  selected: boolean;
  query?: string;
  tall?: boolean;
  onChoose: (location: T) => void;
}) {
  return (
    <Row
      type="button"
      role="option"
      aria-selected={selected}
      $tall={tall}
      onClick={() => onChoose(location)}
      data-testid={`pickup-picker-location-${location.id}`}
    >
      <RowIcon className="muted" aria-hidden>
        <FontAwesomeIcon icon={isAirport(location) ? faPlane : faMapMarkerAlt} />
      </RowIcon>
      <RowText>
        <b>
          <Highlight text={locationPrimaryLabel(location)} query={query} />
        </b>
        <span className="muted">
          <Highlight text={locationSecondaryLabel(location)} query={query} />
        </span>
      </RowText>
    </Row>
  );
}
